import MileageList from "@/components/Mileage/MileageList.vue";
import MileageEdit from "@/components/Mileage/MileageEdit.vue";
import MileageFilter from "@/components/Mileage/MileageFilter.vue";
import MileageHeader from "@/components/Mileage/MileageHeader.vue";

export default [
    {
        path: 'mileage',
        name: 'All Mileages',
        redirect: "/mileage/list",
        components: {
            page: MileageList,
            header: MileageHeader,
        },
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "filter",
                name: "Mileage Filter",
                components: {
                    modal: MileageFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Mileage List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "new",
                name: "Mileage New",
                components: {
                    modal: MileageEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Mileage Edit",
                components: {
                    modal: MileageEdit,
                }
            }
        ]
    }
];